function getPlateforme() {
  console.log('[ENV] NODE_ENV=' + process.env.NODE_ENV);
  let myPlateforme = 'DEV';
  if (process.env.NODE_ENV == 'production') {
    myPlateforme = 'PRODUCTION';
  }
  console.log('[ENV] Plateforme=' + myPlateforme);
  return myPlateforme;
}

function getUrlFront(plateforme) {
  let myURL = '';
  switch (plateforme) {
    case 'DEV' :
      myURL = process.env.REACT_APP_URL_FRONT;
      break;
    default :
      myURL = window.location.origin;
  }
  myURL = myURL + process.env.PUBLIC_URL;
  console.log('[ENV] urlFront=' + myURL);
  return myURL;
}

function getUrlAPI(plateforme) {
  let myURL = '';
  switch (plateforme) {
    case 'DEV' :
      myURL = process.env.REACT_APP_URL_API;
      break;
    default :
      myURL = window.location.origin+'/api-sed';
  }
  console.log('[ENV] urlAPI=' + myURL);
  return myURL;
}

function getUrlAuthentication(plateforme) {
  let myURL = '';
  switch (plateforme) {
    case 'DEV' :
      myURL = process.env.REACT_APP_AUTH_URL;
      break;
    default :
      myURL =  window.location.origin+'/auth';
  }
  console.log('[ENV] urlAuthentication=' + myURL);
  return myURL;
}

function getUrlWebSocket(plateforme) {
  let myURL = '';
  switch (plateforme) {
    case 'DEV' :
      myURL =  process.env.REACT_APP_WS_URL;
      break;
    default :
      myURL =  window.location.origin+'/websocket/realtime/';
  }
  console.log('[ENV] urlWebSocket=' + myURL);
  return myURL;
}

const PLATEFORME = getPlateforme();

export const URL_API = getUrlAPI(PLATEFORME);
export const AUTH_URL = getUrlAuthentication(PLATEFORME);
export const AUTH_REALM = process.env.REACT_APP_AUTH_REALM; // Royaume Keycloak
export const AUTH_CLIENT_ID = process.env.REACT_APP_AUTH_CLIENT_ID;
export const AUTH_DELAY_REFRESH = process.env.REACT_APP_AUTH_DELAY_REFRESH; // Délai pour le refresh token (en s)
export const AUTH_REDIRECT_ROUTE = getUrlFront(PLATEFORME);
export const WS_URL = getUrlWebSocket(PLATEFORME);
export const WEBSOCKET_DELAY_RECONNECT = process.env.REACT_APP_WEBSOCKET_DELAY_RECONNECT; // Délai avant la tentative de reconnexion du websocket (en ms)
export const FLASH_DURATION_NEW_ALERT = process.env.REACT_APP_FLASH_DURATION_NEW_ALERT; // Durée de l'animation des nouvelles alertes (en s)
export const APP_NAME = process.env.REACT_APP_APP_NAME;
export const DEBUG_MODE = (process.env.REACT_APP_DEBUG_MODE === '1') ? true : false;
export const MAX_STORAGE_DETAIL_EQUIP = process.env.REACT_APP_MAX_STORAGE_DETAIL_EQUIP;
